import state from './moduleNotifState.js'
import mutations from './moduleNotifMutations.js'
import actions from './moduleNotifAction.js'
import getters from './moduleNotifGetters.js'

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
